<template>
  <div class="players-data-list">
    <div class="base-info">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>球员信息查询</span>
        </div>
        <el-form :inline="true">
          <el-row>
            <el-form-item label="注册年度">
              <el-select v-model="search.year" @change="quickSearch" placeholder="请选择" style="width:110px;" clearable>
                <el-option
                  v-for="(item, i) in years"
                  :key="i"
                  :label="item.year"
                  :value="item.year" />
              </el-select>
            </el-form-item>
            <el-form-item label="比赛类型">
              <el-select
                style="width: 110px;"
                v-model="search.stageType" @change="quickSearch" placeholder="请选择" clearable>
                <el-option key="0" value="0" label="常规赛"/>
                <el-option key="1" value="1" label="季后赛"/>
              </el-select>
            </el-form-item>
            <el-form-item label="国籍">
              <el-select
                style="width: 110px;"
                v-model="search.nationality" @change="quickSearch" placeholder="请选择" clearable>
                <el-option key="中国" value="中国" />
                <el-option key="其他" value="其他" />
              </el-select>
            </el-form-item>
            <el-form-item label="所属俱乐部">
              <el-select v-model="search.organizationName" @change="quickSearch" placeholder="请选择" style="width:300px;" clearable>
                <el-option
                  v-for="(item, i) in organizationList"
                  :key="i"
                  :label="item.name"
                  :value="item.name" />
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="身份类型">
              <el-select
                style="width: 110px;"
                v-model="search.category" @change="quickSearch" placeholder="请选择" clearable>
                <el-option key="学龄前儿童" value="学龄前儿童" />
                <el-option key="学龄后儿童" value="学龄后儿童" />
                <el-option key="成人" value="成人" />
                <el-option key="北京学生" value="北京学生" />
                <el-option key="外地学生" value="外地学生" />
              </el-select>
            </el-form-item>
            <el-form-item label="当年注册状态">
              <el-select
                style="width: 100px;"
                v-model="search.mStatus" @change="quickSearch" placeholder="请选择" clearable>
                <el-option key="1" value="1" label="已通过" />
              </el-select>
            </el-form-item>
            <el-form-item label="性别">
              <el-select
                style="width: 100px;"
                v-model="search.gender" @change="quickSearch" placeholder="请选择" clearable>
                <el-option key="男" value="男" />
                <el-option key="女" value="女" />
              </el-select>
            </el-form-item>
            <el-form-item label="球员姓名">
              <el-select v-model="search.trueName" filterable remote :remote-method="getPlayerList" @change="quickSearch" placeholder="请选择" style="width:300px;" clearable>
                <el-option
                  v-for="(item, i) in playerList"
                  :key="i"
                  :label="item.trueName"
                  :value="item.trueName" />
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="持杆方式">
              <el-select
                style="width: 110px;"
                v-model="search.stickHand" @change="quickSearch" placeholder="请选择" clearable>
                <el-option key="左手杆" value="左手杆" />
                <el-option key="右手杆" value="右手杆" />
              </el-select>
            </el-form-item>
            <el-form-item label="位置">
              <el-select
                style="width: 110px;"
                v-model="search.position" @change="quickSearch" placeholder="请选择" clearable>
                <el-option key="前锋" value="前锋" />
                <el-option key="后卫" value="后卫" />
                <el-option key="守门员" value="守门员" />
              </el-select>
            </el-form-item>
            <el-form-item label="身高>=">
              <el-input
                style="width: 110px;"
                v-model="search.high"
                @change="quickSearch"
                placeholder="CM"/>
            </el-form-item>
            <el-form-item label="体重>=">
              <el-input
                style="width: 110px;"
                v-model="search.weight"
                @change="quickSearch"
                placeholder="Kg"/>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="主队胜>=">
              <el-input
                style="width: 100px"
                v-model="search.homeWin"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="客队胜>=">
              <el-input
                style="width: 100px;"
                v-model="search.awayWin"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="守丢数>=">
              <el-input
                style="width: 100px;"
                v-model="search.keepLoseCount"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="守住数>=">
              <el-input
                style="width: 100px;"
                v-model="search.keepCount"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="守丢至输数>=">
              <el-input
                style="width: 100px;"
                v-model="search.keepLoseWinCount"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="EQ>=">
              <el-input
                style="width: 110px;"
                v-model="search.eqCount"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="EN>=">
              <el-input
                style="width: 110px;"
                v-model="search.enCount"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="+1>=">
              <el-input
                style="width: 110px;"
                v-model="search.p1Count"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="+2>=">
              <el-input
                style="width: 110px;"
                v-model="search.p2Count"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="-1>=">
              <el-input
                style="width: 110px;"
                v-model="search.m1Count"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="-2>=">
              <el-input
                style="width: 110px;"
                v-model="search.m2Count"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="PS>=">
              <el-input
                style="width: 110px;"
                v-model="search.psCount"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="GWG>=">
              <el-input
                style="width: 110px;"
                v-model="search.gwgCount"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
          </el-row>
          <el-row align="center">
            <el-button type="primary" @click="quickSearch">查询</el-button>
          </el-row>
        </el-form>
      </el-card>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%"
      @sort-change="sortChange"
      :default-sort = "{prop: 'gameCount', order: 'descending'}">
      <el-table-column
        fixed
        prop="trueName">
        <template slot="header" slot-scope="scope">
          <div>头像</div>
        </template>
        <template slot-scope="scope">
          <img :src="scope.row.profile | ImageFormats" style="object-fit: contain; width: 70px;height: 70px;"/>
        </template>
      </el-table-column>
      <el-table-column
        fixed
        label="姓名"
      >
        <template slot-scope="scope">
          <bjh-link :to="getPlayerGamesRouter(scope.row)">{{scope.row.trueName}}</bjh-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="gender"
        label="性别"
      >
      </el-table-column>
      <el-table-column
        prop="position"
        label="位置"
      >
      </el-table-column>
      <el-table-column
        prop="stickHand"
        label="持杆方式"
      >
      </el-table-column>
      <el-table-column
        prop="organizationName"
        label="所属俱乐部"
        width="140"
      >
      </el-table-column>
      <el-table-column
        prop="high"
        label="身高(CM)"
      >
      </el-table-column>
      <el-table-column
        prop="weight"
        label="体重(Kg)"
      >
      </el-table-column>
      <el-table-column
        prop="nationality"
        label="国籍"
      >
      </el-table-column>
      <el-table-column
        prop="category"
        label="类型"
      >
      </el-table-column>
      <el-table-column
        label="比赛场次"
        prop="gameCount"
        sortable="custom"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="homeWin"
        label="主队胜"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="awayWin"
        label="客队胜"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="goalCount"
        label="进球"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="assistCount"
        label="助攻"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="shootoutCount"
        label="点球进球"
        sortable="custom"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="shootoutWinCount"
        label="点球制胜球"
        sortable="custom"
        width="110"
      >
      </el-table-column>
      <el-table-column
        prop="plusCount"
        label="加时(min)"
        sortable="custom"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="plusGoalCount"
        label="加时进球"
        sortable="custom"
        width="110"
      >
      </el-table-column>
      <el-table-column
        prop="penaltyCount"
        label="罚时(min)"
        sortable="custom"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="anyShootCount"
        label="射门"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="eqCount"
        label="EQ"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="enCount"
        label="EN"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="p1Count"
        label="+1"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="p2Count"
        label="+2"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="m1Count"
        label="-1"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="m2Count"
        label="-2"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="psCount"
        label="PS"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="gwgCount"
        label="GWG"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="keepLoseCount"
        label="守丢数"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="keepCount"
        label="守住数"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="keepLoseWinCount"
        label="守丢至输"
        sortable="custom"
        width="100"
      >
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { ImageFormat } from '@/utils'
import { GetPlayersYearsList, getPlayerList } from '@/api/player'
import { getMemberShipYearList } from '@/api/site'
import { getOrganizationList } from '@/api/user'
import * as moment from "moment";

export default {
  name: 'PlayersDataList',
  data() {
    return {
      search: {
        organizationName:null,
        high:null,
        weight:null,
        stickHand:null,
        gender:null,
        position:null,
        nationality:null,
        category:null,
        trueName:null,
        homeWin:null,
        awayWin:null,
        keepLoseCount:null,
        keepCount:null,
        keepLoseWinCount:null,
        eqCount:null,
        enCount:null,
        p1Count:null,
        p2Count:null,
        m1Count:null,
        m2Count:null,
        psCount:null,
        gwgCount:null,
        mStatus:null,
        begin: null,
        end: null
      },
      list: [],
      totalCount: 0, // 默认数据总数
      pageSize: 10, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: true,
      gameCounto:0,
      goalCounto:null,
      assistCounto:null,
      penaltyCounto:null,
      plusCounto:null,
      plusGoalCounto:null,
      shootoutCounto:null,
      shootoutWinCounto:null,
      anyShootCounto:null,
      homeWino:null,
      awayWino:null,
      keepLoseCounto:null,
      keepCounto:null,
      keepLoseWinCounto:null,
      eqCounto:null,
      enCounto:null,
      p1Counto:null,
      p2Counto:null,
      m1Counto:null,
      m2Counto:null,
      psCounto:null,
      gwgCounto:null,
      years:[],
      yearIndex: null,
      organizationList: [],
      playerList: []
    }
  },
  created() {
    this.getMembershipYear()
    this.getMemberList()
    // this.getPlayerList()
    this.getList()
  },
  mounted() {},
  methods: {
    getList(){
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        gameCounto: this.gameCounto,
        goalCounto: this.goalCounto,
        assistCounto: this.assistCounto,
        penaltyCounto: this.penaltyCounto,
        plusCounto: this.plusCounto,
        plusGoalCounto: this.plusGoalCounto,
        shootoutCounto: this.shootoutCounto,
        shootoutWinCounto: this.shootoutWinCounto,
        anyShootCounto: this.anyShootCounto,
        homeWino: this.homeWino,
        awayWino: this.awayWino,
        keepLoseCounto: this.keepLoseCounto,
        keepCounto: this.keepCounto,
        keepLoseWinCounto: this.keepLoseWinCounto,
        eqCounto: this.eqCounto,
        enCounto: this.enCounto,
        p1Counto: this.p1Counto,
        p2Counto: this.p2Counto,
        m1Counto: this.m1Counto,
        m2Counto: this.m2Counto,
        psCounto: this.psCounto,
        gwgCounto: this.gwgCounto
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      GetPlayersYearsList(this.listQuery).then(resolve=>{
        const data = resolve.data
        this.list = data.list
        this.currentPage = data.pageNum
        this.totalCount = data.count
        this.listLoading = false
      })
    },
    getPlayerList(query) {
      if (query !== '') {
        const params = {
          pageSize: 100,
          trueName: query
        }
        getPlayerList(params).then(response => {
          const data = response.data
          this.playerList = data.list
        })
      } else {
        this.playerList = []
      }
    },
    getMemberList() {
      getOrganizationList().then((resolve) => {
        this.organizationList = resolve.data.list
      }, (reject) => {})
    },
    getMembershipYear(){
      getMemberShipYearList({all:1}).then(resolve=>{
        const data = resolve.data
        this.years = data.list
      })
    },
    getPlayerGamesRouter(row) {
      return {path: `/player-games-list?playerId=${row.id}`}
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.$router.push({path: this.$route.path, query: {page: val}})
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    sortChange(p){
      console.log(p)
      const or = p.order ? (p.order.indexOf("desc") >= 0 ? 0 : 1) : null
      this.gameCounto = null
      this.assistCounto = null
      this.goalCounto = null
      this.penaltyCounto = null
      this.shootoutCounto = null
      this.shootoutWinCounto = null
      this.plusCounto = null
      this.plusGoalCounto = null
      this.anyShootCounto = null
      this.homeWino = null
      this.awayWino = null
      this.keepLoseCounto = null
      this.keepCounto = null
      this.keepLoseWinCounto = null
      this.eqCounto = null
      this.enCounto = null
      this.p1Counto = null
      this.p2Counto = null
      this.m1Counto = null
      this.m2Counto = null
      this.psCounto = null
      this.gwgCounto = null

      if(p.prop.indexOf("gameCount") >= 0) {
        this.gameCounto = or
      } else if (p.prop.indexOf("assistCount") >= 0) {
        this.assistCounto = or
      } else if (p.prop.indexOf("goalCount") >= 0) {
        this.goalCounto = or
      } else if (p.prop.indexOf("penaltyCount") >= 0) {
        this.penaltyCounto = or
      } else if (p.prop.indexOf("shootoutCount") >= 0) {
        this.shootoutCounto = or
      } else if (p.prop.indexOf("shootoutWinCount") >= 0) {
        this.shootoutWinCounto = or
      } else if (p.prop.indexOf("plusCount") >= 0) {
        this.plusCounto = or
      } else if (p.prop.indexOf("plusGoalCount") >= 0) {
        this.plusGoalCounto = or
      } else if (p.prop.indexOf("anyShootCount") >= 0) {
        this.anyShootCounto = or
      } else if (p.prop.indexOf("homeWin") >= 0) {
        this.homeWino = or
      } else if (p.prop.indexOf("awayWin") >= 0) {
        this.awayWino = or
      } else if (p.prop.indexOf('keepLoseCount') >= 0) {
        this.keepLoseCounto = or
      } else if (p.prop.indexOf('keepCount') >= 0) {
        this.keepCounto = or
      } else if (p.prop.indexOf('keepLoseWinCount') >= 0) {
        this.keepLoseWinCounto = or
      } else if (p.prop.indexOf('eqCount') >= 0) {
        this.eqCounto = or
      } else if (p.prop.indexOf('enCount') >= 0) {
        this.enCounto = or
      } else if (p.prop.indexOf('p1Count') >= 0) {
        this.p1Counto = or
      } else if (p.prop.indexOf('p2Count') >= 0) {
        this.p2Counto = or
      } else if (p.prop.indexOf('m1Count') >= 0) {
        this.m1Counto = or
      } else if (p.prop.indexOf('m2Count') >= 0) {
        this.m2Counto = or
      } else if (p.prop.indexOf('psCount') >= 0) {
        this.psCounto = or
      } else if (p.prop.indexOf('gwgCount') >= 0) {
        this.gwgCounto = or
      }

      this.getList()
    }
  },
  filters: {
    ImageFormats(img) {
      return ImageFormat.squareImageView(img, 100, 2)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.players-data-list {
  padding: 30px 20px;
  .base-info {
    margin-bottom: 20px;
    .box-card {
      width: 1000px;
      .item {
        padding: 10px 0;
        .title-box {
          font-size: 16px;
          font-weight: 400;
          padding: 6px 0;
        }
        .content-box {
          font-size: 14px;
          font-weight: 400;
          padding: 6px 0;
        }
      }
      .export-btn {
        position: absolute;
        top: 0;
        left: 220px;
      }
      .el-divider {
        margin: 10px 0;
      }
    }
  }
  .el-table {
    th {
      div {
        line-height: 20px;
      }
      .el-select {
        padding-left: 0;
        padding-right: 0;
        .el-input {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
    th>{
      .cell {
        text-overflow: clip;
      }
    }
  }
  .table-footer {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
